import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import dateformat from 'dateformat';
import debounce from 'lodash.debounce';
import RightSlider from './RightSlider.js';
import { selectorButtonCss, selectorButtonSelectedCss, selectorButtonSmallCss, } from './utils/selectorButtonStyles.js';
const BUTTON_SKIP = 'Skip';
const BUTTON_JUMP = 'Jump';
const actionListItemTimeCss = (theme) => ({
    display: 'inline',
    padding: '4px 6px',
    borderRadius: '3px',
    fontSize: '0.8em',
    lineHeight: '1em',
    flexShrink: 0,
    backgroundColor: theme.ACTION_TIME_BACK_COLOR,
    color: theme.ACTION_TIME_COLOR,
});
export default class ActionListRow extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = { hover: false };
        this.handleMouseEnter = (e) => {
            if (this.state.hover)
                return;
            this.handleMouseLeave.cancel();
            this.handleMouseEnterDebounced(e.buttons);
        };
        this.handleMouseEnterDebounced = debounce((buttons) => {
            if (buttons)
                return;
            this.setState({ hover: true });
        }, 150);
        this.handleMouseLeave = debounce(() => {
            this.handleMouseEnterDebounced.cancel();
            if (this.state.hover)
                this.setState({ hover: false });
        }, 100);
        this.handleMouseDown = (e) => {
            if (e.target.dataset.isselectorbutton)
                return;
            this.handleMouseLeave();
        };
    }
    render() {
        const { isSelected, action, actionId, isInitAction, onSelect, timestamps, isSkipped, isInFuture, hideActionButtons, } = this.props;
        const { hover } = this.state;
        const timeDelta = timestamps.current - timestamps.previous;
        const showButtons = (hover && !isInitAction) || isSkipped;
        const isButtonSelected = (btn) => btn === BUTTON_SKIP && isSkipped;
        let actionType = action.type;
        if (typeof actionType === 'undefined')
            actionType = '<UNDEFINED>';
        else if (actionType === null)
            actionType = '<NULL>';
        else
            actionType = actionType.toString() || '<EMPTY>';
        return (_jsxs("div", { onClick: onSelect, onMouseEnter: (!hideActionButtons &&
                this.handleMouseEnter), onMouseLeave: (!hideActionButtons &&
                this.handleMouseLeave), onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseEnter, "data-id": actionId, css: [
                (theme) => ({
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    userSelect: 'none',
                    borderBottomColor: theme.BORDER_COLOR,
                }),
                isSelected &&
                    ((theme) => ({
                        backgroundColor: theme.SELECTED_BACKGROUND_COLOR,
                    })),
                isSkipped &&
                    ((theme) => ({
                        backgroundColor: theme.SKIPPED_BACKGROUND_COLOR,
                    })),
                isInFuture && { opacity: '0.6' },
            ], children: [_jsx("div", { css: [
                        {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '20px',
                        },
                        isSkipped && { textDecoration: 'line-through', opacity: 0.3 },
                    ], children: actionType }), hideActionButtons ? (_jsx(RightSlider, { shown: true, children: _jsx("div", { css: actionListItemTimeCss, children: timeDelta === 0
                            ? '+00:00:00'
                            : dateformat(timeDelta, timestamps.previous ? '+MM:ss.L' : 'h:MM:ss.L') }) })) : (_jsxs("div", { css: { position: 'relative', height: '20px', display: 'flex' }, children: [_jsx(RightSlider, { shown: !showButtons, rotate: true, children: _jsx("div", { css: actionListItemTimeCss, children: timeDelta === 0
                                    ? '+00:00:00'
                                    : dateformat(timeDelta, timestamps.previous ? '+MM:ss.L' : 'h:MM:ss.L') }) }), _jsx(RightSlider, { shown: showButtons, rotate: true, children: _jsx("div", { css: { display: 'inline-flex' }, children: [BUTTON_JUMP, BUTTON_SKIP].map((btn) => (!isInitAction || btn !== BUTTON_SKIP) && (_jsx("div", { onClick: (e) => this.handleButtonClick(btn, e), css: [
                                        selectorButtonCss,
                                        isButtonSelected(btn) && selectorButtonSelectedCss,
                                        selectorButtonSmallCss,
                                    ], "data-isselectorbutton": true, children: btn }, btn))) }) })] }))] }));
    }
    handleButtonClick(btn, e) {
        e.stopPropagation();
        switch (btn) {
            case BUTTON_SKIP:
                this.props.onToggleClick();
                break;
            case BUTTON_JUMP:
                this.props.onJumpClick();
                break;
        }
    }
}
